import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react';
import { auth, onIdTokenChanged, type User } from './firebase';

interface AuthContextValue {
  user: User | null;
  loading: boolean;
}

const Ctx = createContext<AuthContextValue>({ user: null, loading: true });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const off = onIdTokenChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return off;
  }, []);

  return <Ctx.Provider value={{ user, loading }}>{children}</Ctx.Provider>;
}

export function useAuth() {
  return useContext(Ctx);
}
